let baseUrl;

if (window.location.hostname === 'www.liabilityinsuranceapps.com') {
    baseUrl = 'https://www.liabilityinsuranceapps.com/';
} else {
    baseUrl = process.env.VUE_APP_BASE_URL || 'https://orep.org/';
}

export const BASE_URL = baseUrl;

export const STATUS = {
  'Draft': 1,
  'Submitted': 2,
  'Under_Review': 3,
  'Approved': 4
};
export const APP_STATUS = {
  'Not_Completed': 1,
  'Partially_Completed': 2,
  'Under_Review': 3,
  'Completed': 4,
};
export const STATES = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FL": "Florida",
    "GA": "Georgia",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PA": "Pennsylvania",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
};

export const HEAR_ABOUT_US_AX_APPRAISERS  = {
    "Working RE Magazine": "Working RE Magazine",
    "Met at a Conference": "Met at a Conference",
    "Dustin Harris Podcast": "Dustin Harris Podcast",
    "Friend or Colleague": "Friend or Colleague",
    "Google Search Results": "Google Search Results",
    "Other": "Other",
};

export const HEAR_ABOUT_US_APPRAISERS  = {
    "Email Advertisement": "Email Advertisement",
    "Met at a Conference": "Met at a Conference",
    "Google Search": "Google Search",
    "Friend or Colleague": "Friend or Colleague",
    "Postcard": "Postcard",
    "Other": "Other",
};

export const HEAR_ABOUT_US_HI = {
    "Home Inspector Magazine": "Home Inspector Magazine",
    "Met at a Conference": "Met at a Conference",
    "School/Instructor Recommended You": "School/Instructor Recommended You",
    "Friend or Colleague": "Friend or Colleague",
    "Google Search Results": "Google Search Results",
    "Postcard" : "Postcard",
    "Other": "Other",
};

export const HEAR_ABOUT_US_PI = {
    "Working RE Magazine": "Working RE Magazine",
    "Met at a Conference": "Met at a Conference",
    "Friend or Colleague": "Friend or Colleague",
    "Google Search Results": "Google Search Results",
    "Postcard" : "Postcard",
    "Other": "Other",
};

export const HEAR_ABOUT_US_PPI = {
    "Working PI Magazine": "Working PI Magazine",
    "Met at a Conference": "Met at a Conference",
    "Friend or Colleague": "Friend or Colleague",
    "Google Search Results": "Google Search Results",
    "Postcard" : "Postcard",
    "Other": "Other",
};

export const HEAR_ABOUT_US_BROKERS = {
    "Email Advertisement": "Email Advertisement",
    "Met at a Conference": "Met at a Conference",
    "Friend or Colleague": "Friend or Colleague",
    "Google Search Results": "Google Search Results",
    "Postcard" : "Postcard",
    "Other": "Other",
};

export const HEAR_ABOUT_US_IA = {
    "Email Advertisement": "Email Advertisement",
    "Producer’s Edge Print": "Producer’s Edge Print",
    "Met at a Conference": "Met at a Conference",
    "Network Recommended You": "Network Recommended You",
    "Association Recommended You": "Association Recommended You",
    "Friend or Colleague": "Friend or Colleague",
    "Google Search Results": "Google Search Results",
    "Postcard" : "Postcard",
    "Other": "Other",
};


export const YEARS = {
  "2025": "2025",
  "2024": "2024",
  "2023": "2023",
  "2022": "2022",
  "2021": "2021",
  "2020": "2020",
  "2019": "2019",
  "2018": "2018",
  "2017": "2017",
  "2016": "2016",
  "2015": "2015",
  "2014": "2014",
  "2013": "2013",
  "2012": "2012",
  "2011": "2011",
  "2010": "2010",
  "2009": "2009",
  "2008": "2008",
  "2007": "2007",
  "2006": "2006",
  "2005": "2005",
  "2004": "2004",
  "2003": "2003",
  "2002": "2002",
  "2001": "2001",
  "2000": "2000 or Earlier",


};

export const COVERAGES = [
  '1M/1M',
  '0.5M/0.5M',
  '0.1M/0.3M',
  '0.3M/0.3M',
  'other'
];


// constants.js
export const FORM_IDS = {
    HOME_INSPECTOR:              175774,
    STANDARD_APPLICATION:        175775,
    RX_APPLICATION:              175776,
    AX_APPLICATION:              175777,
    PI_APPLICATION:              175778,
    SIP_APPLICATION:             175779,
    PPI_APPLICATION:             175780,
    QUICK_QUOTE:                 175781,
    RC_APPLICATION:              175782,
    INSURANCE_AGENT_APPLICATION: 175783,
    MGA_APPLICATION:             175784
};

